import React from 'react';
import axios from 'axios';
import {Switch, Route, withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import AvatarForm from './AvatarForm';
import AvatarList from "./AvatarList";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';


class Avatars extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            size: {
                width: 200,
                height: 200
            }
        };


        // Create, Update, Delete handles
        this.handleAddAvatar = this.handleAddAvatar.bind(this);
        this.handleEditAvatar = this.handleEditAvatar.bind(this);
        this.handleRemoveAvatar = this.handleRemoveAvatar.bind(this);
    }

    handleAddAvatar(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.avatars, {
            ...values
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Avatar ' + response.data.name + ' byl vytvořen.');
            this.props.history.push('/avatars');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Avatara se nepodařilo vytvořit!');
            this.props.history.push('/avatars');
            console.log('Axios error:', error);
        });
    }

    handleEditAvatar(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.put(this.props.api.avatars + "/"+ values.id, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Avatar ' + response.data.name + ' byl upraven.');
            this.props.history.push('/avatars');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Avatara se nepovedlo upravit!');
            this.props.history.push('/avatars');
            console.log('Axios axios:', error);
        });
    }

    handleRemoveAvatar(avatar) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.delete(this.props.api.avatars + "/" + avatar.id, config).then((response) => {
            this.props.addNotification('success', response.status, 'Avatar ' + avatar.name + ' byl odstraněn.');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Avatara ' + avatar.name + ' se nepodařilo odstranit!');
            console.log('Axios error: ', error);
        });
    }

    render() {
        let {size} = this.state;

        return (
            /* page content */
            <div id="page-avatars" className="right-col" role="main">
                <div className="page-title">
                    <div className="title-left"><h3>Avataři</h3></div>
                </div>
                <Switch>
                    <Route exact path="/avatars" component={() =>
                        <AvatarList
                            {...this.props}
                            size={size}
                            handleRemoveAvatar={this.handleRemoveAvatar}
                        />}
                    />
                    <Route path="/avatars/add" component={() =>
                        <AvatarForm
                            {...this.props}
                            title="Přidání avatara"
                            button="Přidat"
                            size={this.state.size}
                            action={this.handleAddAvatar}
                        />
                    }
                    />
                    <Route path="/avatars/edit/:id" component={() =>
                        <AvatarForm
                            {...this.props}
                            title="Úprava avatara"
                            button="Upravit"
                            size={this.state.size}
                            action={this.handleEditAvatar}
                        />
                    }
                   />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Avatars));



/** WEBPACK FOOTER **
 ** ./src/containers/Avatars/index.js
 **/